// extracted by mini-css-extract-plugin
module.exports = {"counter-button":"counter-button_counter-button__FV7AB","contained":"counter-button_contained__QnHxC","value":"counter-button_value__X9mX4"};